import React from 'react';
import MusicAlbumReleaseStepsView from './MusicAlbumReleaseStepsView';
import MusicAlbumEditForm2ListView from './MusicAlbumEditForm2ListView';
import MusicAlbumCorrectionRequestView from './MusicAlbumCorrectionRequestView';
import CustomButton from '../../../common/components/CustomButton';
import ErrorMessage from '../../../common/components/ErrorMessage';
import { MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity, MusicFeaturingArtistEntity } from '../../types/MusicEntityTypes';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

export default function MusicAlbumEditForm2View({
  musicAlbum,
  musicAlbumTracks,
  getErrors,
  onSelect,
  onCancel,
  onSort,
  onMovePrev,
  onMoveNext,
  onDelete,
  onSubmit,
  onStep,
} : {
  musicAlbum: MusicAlbumEntity & { music_album_tracks: MusicAlbumTrackEntity[] },
  musicAlbumTracks: (MusicAlbumTrackEntity & { music: MusicEntity })[],
  getErrors: () => FieldValidationErrorsType,
  onSelect: () => void,
  onCancel: () => void,
  onSort: (ids: string[]) => void,
  onMovePrev: (musicAlbumTrack: MusicAlbumTrackEntity, trackNo: number) => void,
  onMoveNext: (musicAlbumTrack: MusicAlbumTrackEntity, trackNo: number) => void,
  onDelete: (musicAlbumTrack: MusicAlbumTrackEntity) => void,
  onSubmit: () => void,
  onStep: (callback: ((musicAlbumId: number) => void)) => void,
}) {
  return (
    <>
      <MusicAlbumReleaseStepsView
        step={2}
        musicAlbum={musicAlbum}
        onClick={(callback) => { onStep(callback); }}
      />
      <MusicAlbumCorrectionRequestView musicAlbum={musicAlbum} />
      <form className="music_list cake_ajax_form">
        <div className="form__body">
          <span className="info">このリリースに収録する曲を選んでください。</span>
          <CustomButton type="add" onClick={() => onSelect()}>
            曲を選ぶ
          </CustomButton>
        </div>
        <p className="info">
          曲の順序を変更したい場合は、ここで入れ替えましょう！
          <span className="pc_only">ドラッグ＆ドロップで入れ替えることもできます。</span>
        </p>
        <MusicAlbumEditForm2ListView
          musicAlbumTracks={musicAlbumTracks}
          onSort={onSort}
          onMovePrev={onMovePrev}
          onMoveNext={onMoveNext}
          onDelete={onDelete}
        />
        <ErrorMessage type="error" validationErrors={getErrors()} />
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => onCancel()}>戻る</CustomButton>
            <CustomButton type="default-split" onClick={() => onSubmit()}>次へ</CustomButton>
          </li>
        </ul>
      </form>
    </>
  );
}
